import { z } from 'zod';

/** What the CRM accepts; the type is read from the file itself. */
export const documentContentTypes = [
  'application/pdf',
  'image/jpeg',
  'image/png',
  'image/webp',
] as const;
export const MAX_DOCUMENT_BYTES = 20 * 1024 * 1024;

export const documentSchema = z.object({
  id: z.string(),
  /** null for a company-wide document. */
  objectId: z.string().nullable(),
  title: z.string(),
  fileName: z.string(),
  contentType: z.string(),
  sizeBytes: z.number().int(),
  uploadedByUserId: z.number().int(),
  createdAt: z.string().nullable(),
});
export type DocumentFile = z.infer<typeof documentSchema>;

/** Form fields sent with the file (multipart/form-data, field "file"). */
export const documentUploadFieldsSchema = z.object({
  title: z.string().trim().max(200, 'Не длиннее 200 символов').default(''),
  objectId: z.union([z.literal(''), z.uuid()]).default(''),
});

export const documentFilterSchema = z.object({
  objectId: z.uuid().optional(),
  /** Only company-wide documents. */
  company: z.coerce.boolean().optional(),
});

export const documentParamsSchema = z.object({
  organizationId: z.coerce.number().int().positive(),
  documentId: z.uuid(),
});
